export enum PickemTypeEnum {
  PUBLIC = 0,
  PRIVATE = 1,
}

export enum PickemStatusEnum {
  DRAFT = 'DRAFT',
  UPCOMING = 'UPCOMING',
  IN_PLAY = 'IN_PLAY',
  COMPLETE = 'COMPLETE',
}

export enum ViewTypeEnum {
  PLAYER_LIST = 'PLAYER_LIST',
  TEAM_LIST = 'TEAM_LIST',
  MULTIPLE_OPTIONS = 'MULTIPLE_OPTIONS',
  OVER_UNDER = 'OVER_UNDER',
  SIX_OPTIONS = 'SIX_OPTIONS',
  PCT_OPTIONS = 'PCT_OPTIONS',
}
